import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("polygon", { points: "0,5 4,5 10,13 16,5 20,5 12,15 20,25 16,25 10,17 4,25 0,25 8,15" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: 20 * _ctx.scale,
    height: 30 * _ctx.scale,
    viewBox: "0 0 20 30"
  }, _hoisted_3, 8, _hoisted_1))
}